import { FunctionComponent } from 'react';
import styles from './DonationPromptDots.module.scss';

export type DonationPromptDotsProps = {
  numberOfTiles: number;
  selectTile: (index: number) => void;
  activeTile: number;
};

export const DonationPromptDots: FunctionComponent<DonationPromptDotsProps> = ({
  numberOfTiles,
  selectTile,
  activeTile,
}) => {
  activeTile = activeTile > numberOfTiles || activeTile < 0 ? 0 : activeTile;
  const dots: React.ReactElement[] = [];
  for (let i = 0; i < numberOfTiles; i++) {
    const dot = (
      <button
        key={`dot-${i}`}
        aria-label={`prompt-${i}`}
        className={i === activeTile ? styles.dotActive : styles.dot}
        onClick={() => selectTile(i)}
      />
    );
    dots.push(dot);
  }

  return (
    <div className={styles.dots} role="navigation">
      {dots}
    </div>
  );
};
